import { orderBy } from 'es-toolkit';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import {
  PRODUCT_SORT_OPTIONS,
  PRODUCT_COLOR_OPTIONS,
  PRODUCT_GENDER_OPTIONS,
  PRODUCT_RATING_OPTIONS,
  PRODUCT_CATEGORY_OPTIONS,
} from 'src/_mock';

import { ProductSearch } from 'src/components/search';

import { ProductSort } from '../product-sort';
import { ProductFiltersDrawer } from '../product-filters-drawer';

// ----------------------------------------------------------------------

export function RenderFilters({
  list,
  seller,
  sortBy,
  filters,
  maxValue,
  canReset,
  setSortBy,
  renderTitle,
  hideShopName,
  updateParams,
  onResetParams,
}) {
  const handleSortBy = (newValue) => {
    if (list === 'shop') {
      updateParams('sortBy', newValue);
    } else if (list === 'search') {
      setSortBy(newValue);
    }
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={{ xs: 1, md: 0 }}
      justifyContent={hideShopName ? 'flex-end' : 'space-between'}
    >
      {!hideShopName && (
        <Box sx={[(theme) => ({ [theme.breakpoints.down('md')]: { display: 'none' } })]}>
          {renderTitle()}
        </Box>
      )}

      <ProductSearch seller={hideShopName ? seller : null} sx={{ display: { md: 'none' } }} />

      {(list === 'shop' || list === 'search') && (
        <Stack
          flexShrink={0}
          direction="row"
          spacing={{ xs: 1, md: 0 }}
          sx={[
            (theme) => ({
              [theme.breakpoints.down('md')]: { right: 16, zIndex: 999, position: 'absolute' },
            }),
          ]}
        >
          <ProductFiltersDrawer
            filters={filters}
            canReset={canReset}
            maxValue={maxValue}
            updateParams={updateParams}
            onResetParams={onResetParams}
            options={{
              colors: PRODUCT_COLOR_OPTIONS,
              ratings: PRODUCT_RATING_OPTIONS,
              genders: PRODUCT_GENDER_OPTIONS,
              categories: ['all', ...PRODUCT_CATEGORY_OPTIONS.map(({ name }) => name)],
            }}
          />

          <ProductSort sort={sortBy} onSort={handleSortBy} sortOptions={PRODUCT_SORT_OPTIONS} />
        </Stack>
      )}
    </Stack>
  );
}

export function applyFilter({ inputData, filters, sortby, list, maxValue }) {
  const { gender, category, colors, priceRange, rating } = filters;

  const min = priceRange[0];
  const max = priceRange[1];

  // Sort by
  if (list === 'search') {
    if (sortby === 'featured') {
      inputData = orderBy(inputData, ['totalReviews'], ['desc']);
      inputData = orderBy(inputData, ['totalRating'], ['desc']);
    }

    if (sortby === 'priceDesc') {
      inputData = orderBy(inputData, ['priceSale'], ['desc']);
    }

    if (sortby === 'priceAsc') {
      inputData = orderBy(inputData, ['priceSale'], ['asc']);
    }

    if (sortby === 'newest') {
      inputData = orderBy(inputData, ['createdAt'], ['desc']);
    }
  }

  // filters
  if (gender.length) {
    inputData = inputData.filter((product) => product.gender.some((i) => gender.includes(i)));
  }

  if (category !== 'all' && list === 'search') {
    inputData = inputData.filter((product) => product.category === category);
  }

  if (colors.length) {
    inputData = inputData.filter((product) =>
      product.colors.some((color) => colors.includes(color))
    );
  }

  if (min !== 0 || (max !== maxValue && list === 'search')) {
    inputData = inputData.filter((product) => product.priceSale >= min && product.priceSale <= max);
  }

  if (rating) {
    inputData = inputData.filter((product) => {
      const convertRating = (value) => {
        if (value === '+4') return 4;
        if (value === '+3') return 3;
        if (value === '+2') return 2;
        return 1;
      };
      return product.totalRating > convertRating(rating);
    });
  }

  return inputData;
}
